import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { ROUTES } from 'src/app/route/routes';
import { UserService } from 'src/app/service/user.service';
import { Subject } from 'rxjs';
import { FluxService } from 'src/app/service/flux-service';

@Component({
  selector: 'app-delete-completed',
  templateUrl: './delete-completed.component.html',
  styleUrls: ['./delete-completed.component.scss'],
  standalone: false
})
export class DeleteCompletedComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  isSuccess: boolean = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public userService: UserService,
    private spinner: SpinnerService,
    private fluxService: FluxService
  ) { }

  ngOnInit() {
    this.fluxService.initializeFromRoute(this.route);
    this.spinner.hide();
  }

  ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
  }

  get successImage() {
    if (this.isSuccess) {
      return "../../../assets/img/check.svg"
    } else {
      return "../../../assets/img/alert.svg"
    }
  }

  goToEventList() {
    const currentFlux = this.fluxService.getCurrentFlux();
    this.router.navigate([currentFlux+ '/' + ROUTES.EVENT_LIST.path]);
  }

  termina() {
    if (this.userService.isEmployeeWithoutPassenger() || this.userService.uuidPassenger) {
      window.opener.focus();
      window.close();
    }
  }

}
